"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _auth = require("@/utils/auth");
var _login = _interopRequireDefault(require("@/services/modules/login"));
var _WorkOrderEntity = _interopRequireDefault(require("@services/WorkOrderEntity"));
var _system = _interopRequireDefault(require("@services/system"));
var _elementUi = require("element-ui");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var user = {
  state: {
    token: (0, _auth.getToken)(),
    name: '',
    avatar: '',
    roles: [],
    roleIds: [],
    permissions: [],
    treeArray: [],
    treeArray2: [],
    permission: true,
    updateNumber: 0,
    // operate===
    Backlog_num: -1,
    Pending_num: -1,
    InHand_num: -1,
    ToBeConfirmed_num: -1,
    // end
    updateNumberMessage: -1,
    ifCache: -3,
    roleListArr: [],
    pendingArr: -1,
    overList: []
  },
  mutations: {
    SET_PENDING_ARR: function SET_PENDING_ARR(state, data) {
      state.pendingArr = data + state.pendingArr;
    },
    SET_OVER_LIST: function SET_OVER_LIST(state, data) {
      state.overList = data;
    },
    SET_IF_CODE: function SET_IF_CODE(state, data) {
      state.ifCache = data + state.ifCache;
    },
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_TREEARRAY: function SET_TREEARRAY(state, data) {
      state.treeArray = data;
    },
    SET_TREEARRAY2: function SET_TREEARRAY2(state, data) {
      state.treeArray2 = data;
    },
    SET_ID: function SET_ID(state, expires_in) {
      state.expires_in = expires_in;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_ROLEIDS: function SET_ROLEIDS(state, roleIds) {
      state.roleIds = roleIds;
    },
    SET_PERMISSIONS: function SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    },
    UPDATA_NUMBER: function UPDATA_NUMBER(state, permissions) {
      state.updateNumber = permissions;
      // ======
      state.Backlog_num = permissions.my_edit_number.count;
      state.Pending_num = permissions.my_get_status1.count;
      state.InHand_num = permissions.my_get_status2.count;
      state.ToBeConfirmed_num = permissions.my_get_status3.count;
    },
    UPDATE_NUMBER_message: function UPDATE_NUMBER_message(state, permissions) {
      state.updateNumberMessage = permissions;
    },
    roleListArr: function roleListArr(state, _roleListArr) {
      state.roleListArr = _roleListArr;
    }
  },
  actions: {
    // 处理中
    getPending: function () {
      var _getPending = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, data) {
        var commit;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              commit('SET_PENDING_ARR', data);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getPending(_x, _x2) {
        return _getPending.apply(this, arguments);
      }
      return getPending;
    }(),
    // 获取超时工单
    getOvertime: function () {
      var _getOvertime = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
        var commit, params, _yield$EntityService$, data, code;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              params = {
                action: 'get',
                // workorder_status: 1,
                row: 20,
                page: 1,
                checked: false,
                is_overtime: 1
              };
              _context2.next = 4;
              return _WorkOrderEntity.default.getList(params);
            case 4:
              _yield$EntityService$ = _context2.sent;
              data = _yield$EntityService$.data;
              code = _yield$EntityService$.code;
              if (code === 200) {
                commit('SET_OVER_LIST', data);
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getOvertime(_x3) {
        return _getOvertime.apply(this, arguments);
      }
      return getOvertime;
    }(),
    // 获取数量
    getCache: function () {
      var _getCache = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3, code) {
        var commit;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              commit('SET_IF_CODE', code);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getCache(_x4, _x5) {
        return _getCache.apply(this, arguments);
      }
      return getCache;
    }(),
    getNumber: function () {
      var _getNumber = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4) {
        var commit, _yield$EntityService$2, data, code;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;
              _context4.next = 3;
              return _WorkOrderEntity.default.number();
            case 3:
              _yield$EntityService$2 = _context4.sent;
              data = _yield$EntityService$2.data;
              code = _yield$EntityService$2.code;
              if (code === 200) {
                commit('UPDATA_NUMBER', data);
              } else {
                // this.$message.error(msg)
                commit('UPDATA_NUMBER', 0);
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function getNumber(_x6) {
        return _getNumber.apply(this, arguments);
      }
      return getNumber;
    }(),
    // 获取铃铛数量
    getMessageNumber: function () {
      var _getMessageNumber = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref5) {
        var commit, _yield$EntityService$3, data, code;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref5.commit;
              _context5.next = 3;
              return _WorkOrderEntity.default.numberMessage();
            case 3:
              _yield$EntityService$3 = _context5.sent;
              data = _yield$EntityService$3.data;
              code = _yield$EntityService$3.code;
              if (code === 200) {
                commit('UPDATE_NUMBER_message', data);
              } else {
                // this.$message.error(msg)
                commit('UPDATA_NUMBER', 0);
              }
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function getMessageNumber(_x7) {
        return _getMessageNumber.apply(this, arguments);
      }
      return getMessageNumber;
    }(),
    // 获取角色列表
    getRoleList: function () {
      var _getRoleList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref6) {
        var _this = this;
        var commit, state, site_id, _yield$SystemService$, msg, code, data, roleList;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref6.commit, state = _ref6.state;
              site_id = localStorage.getItem('siteId'); // if (!state.roleListArr.length) {
              _context6.next = 4;
              return _system.default.lookRoleList({
                site_id: site_id
              });
            case 4:
              _yield$SystemService$ = _context6.sent;
              msg = _yield$SystemService$.msg;
              code = _yield$SystemService$.code;
              data = _yield$SystemService$.data;
              if (code !== 200) {
                _elementUi.Message.error(msg);
              }
              roleList = data.reverse();
              commit('roleListArr', roleList);
              // }
              return _context6.abrupt("return", new Promise(function (resolve, reject) {
                _system.default.roleList({
                  name: '',
                  size: 300,
                  pid: process.env.VUE_APP_PID
                }).then(function (res) {
                  var data = res.data,
                    code = res.code,
                    msg = res.msg;
                  if (code !== 0) {
                    return _this.$message.error(msg);
                  }
                  var tableArray = [];
                  var tableArray2 = [];
                  state.roleListArr.map(function (item) {
                    data.data.map(function (ele) {
                      if (item.role_name === ele.name) {
                        item.id = ele.id;
                        // ele.website_name = item.site_name
                        // debugger
                        tableArray.push(item);
                        tableArray2.push(ele);
                      }
                    });
                  });
                  commit('SET_TREEARRAY', tableArray);
                  commit('SET_TREEARRAY2', tableArray2);
                  resolve(tableArray2);
                }).catch(function (e) {
                  reject(e);
                });
              }));
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function getRoleList(_x8) {
        return _getRoleList.apply(this, arguments);
      }
      return getRoleList;
    }(),
    // 登录
    Login: function Login(_ref7, userInfo) {
      var commit = _ref7.commit;
      return new Promise(function (resolve, reject) {
        _login.default.login(_objectSpread(_objectSpread({}, userInfo), {}, {
          name: userInfo.username
        })).then(function (res) {
          // debugger
          localStorage.setItem('userName', userInfo.username);
          localStorage.setItem('password', userInfo.password);
          if (res.code === 0) {
            // 下面存储=================
            localStorage.setItem('name', userInfo.username);
            localStorage.setItem('userNickname', res.data.nickname);
            localStorage.setItem('uid', res.data.uid);
            // ========================end
            var token = res.data.access_token;
            var websites = JSON.stringify(res.data.websites);
            localStorage.setItem('websites', websites);
            localStorage.setItem('token', token);
            localStorage.setItem('shareId', res.data.auth_group_list.length ? res.data.auth_group_list[0].id : '');
            var arr = res.data.auth_group_list.length ? res.data.auth_group_list.map(function (item) {
              return item.name;
            }) : [];
            localStorage.setItem('group', String(arr));
            (0, _auth.setToken)(token);
            commit('SET_TOKEN', token);
            var roleIds = [];
            var roleIdsName = [];
            var roleIds_2 = res.data.auth_group_list;
            roleIds_2.forEach(function (item) {
              roleIds.push(item.id);
              roleIdsName.push(item.name);
            });
            var roleIds_3 = roleIds.join(',');
            var roleIdsName_2 = roleIdsName.join(',');
            localStorage.setItem('roleIds', roleIds_3);
            localStorage.setItem('roleIdsName', roleIdsName_2);
            commit('SET_ROLEIDS', roleIds);
            resolve(res);
          } else {
            // reject(res)
            resolve(res);
          }
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    // 获取用户信息
    GetInfo: function GetInfo(_ref8) {
      var commit = _ref8.commit;
      return new Promise(function (resolve) {
        // 二次修改 抛出用户信息，不进行请求
        var res = {
          code: 0,
          data: {
            username: '',
            role_id: 0
          }
        };
        var _res = {
          msg: '操作成功',
          code: 200,
          permissions: ['*:*:*'],
          roles: ['admin']
        };
        if (_res.roles && _res.roles.length > 0) {
          // 验证返回的roles是否是一个非空数组
          commit('SET_ROLES', [res.data.role_id]);
          commit('SET_PERMISSIONS', _res.permissions);
        } else {
          commit('SET_ROLES', ['ROLE_DEFAULT']);
        }
        commit('SET_NAME', res.data.username);
        var avatar = require('@/assets/image/profile.jpg');
        commit('SET_AVATAR', avatar);
        resolve(res);
      });
    },
    // 退出系统
    LogOut: function LogOut(_ref9) {
      var commit = _ref9.commit;
      return new Promise(function (resolve) {
        localStorage.removeItem('token');
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('SET_PERMISSIONS', []);
        (0, _auth.removeToken)();
        resolve();
      });
    },
    // 前端 登出
    FedLogOut: function FedLogOut(_ref10) {
      var commit = _ref10.commit;
      return new Promise(function (resolve) {
        commit('SET_TOKEN', '');
        (0, _auth.removeToken)();
        resolve();
      });
    }
  }
};
var _default = exports.default = user;